import { getTablePoint, getVisibleColumnIds } from "./viewLayout.js";
import { calcMemoHeight, calcMemoWidth } from "../../utils/calcMemo.js";
import { calcTableWidths, calcViewTableWidths, tableHeaderHeight, tableRowHeight } from "../../utils/calcTable.js";
import { tableToObjectPoint } from "../../utils/draw-relationship/calc.js";
//#region src/konva/scene/metrics.ts
function unionRect(a, b) {
	const x = Math.min(a.x, b.x);
	const y = Math.min(a.y, b.y);
	return {
		x,
		y,
		width: Math.max(a.x + a.width, b.x + b.width) - x,
		height: Math.max(a.y + a.height, b.y + b.height) - y
	};
}
var TABLE_INSET = 9;
function getTableRect(state, table, source = "document") {
	const { width, height } = tableToObjectPoint(state, table, source);
	const { x, y } = getTablePoint(state, table, source);
	return {
		x,
		y,
		width,
		height
	};
}
function getTableWidths(state, table, source = "document") {
	return source === "document" ? calcTableWidths(table, state) : calcViewTableWidths(table, state, getVisibleColumnIds(state, table, source));
}
function getColumnRect(state, table, index, source = "document") {
	const { x, y, width } = getTableRect(state, table, source);
	const rowHeight = tableRowHeight(source);
	return {
		x: x + TABLE_INSET,
		y: y + TABLE_INSET + tableHeaderHeight(source) + index * rowHeight,
		width: width - TABLE_INSET * 2,
		height: rowHeight
	};
}
function getTableHeaderRect(state, table, source = "document") {
	const { x, y, width } = getTableRect(state, table, source);
	return {
		x,
		y,
		width,
		height: TABLE_INSET + tableHeaderHeight(source)
	};
}
function getMemoRect(memo) {
	const { x, y } = memo.ui;
	return {
		x,
		y,
		width: calcMemoWidth(memo),
		height: calcMemoHeight(memo)
	};
}
//#endregion
export { getColumnRect, getMemoRect, getTableHeaderRect, getTableRect, getTableWidths, unionRect };
